import React from 'react';
import { Wrapper, Footer } from '../components';

class Illustrations extends React.Component{
    render(){
        return (
            <Wrapper>
                <h4 className="font-weight-light">Vector Illustrations</h4>
                <p>Need artwork for your project? Utilize these beautiful, <b>open-source</b> scalable images from <a href="https://undraw.co/" target="_new">unDraw</a>!</p>
                <div className="row flex-grow-1 mb-3">
                    <div className="col-sm-6 col-md-4 col-lg-3 py-3">
                        <div className="card wow zoomIn shadow-sm">
                            <div className="card-header text-primary text-uppercase small">Profile</div>
                            <div className="card-body pt-4">
                                <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                  <image href="assets/undraw/undraw_profile.svg" x="0" y="0" height="100" width="100" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 py-3">
                        <div className="card wow zoomIn shadow-sm">
                            <div className="card-header text-primary text-uppercase small">Online</div>
                            <div className="card-body pt-4">
                                <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                  <image href="assets/undraw/undraw_online.svg" x="0" y="0" height="100" width="100" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 py-3">
                        <div className="card wow zoomIn shadow-sm">
                            <div className="card-header text-primary text-uppercase small">Map</div>
                            <div className="card-body pt-4">
                                <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                  <image href="assets/undraw/undraw_map.svg" x="0" y="0" height="100" width="100" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 py-3">
                        <div className="card wow zoomIn shadow-sm">
                            <div className="card-header text-primary text-uppercase small">Sync</div>
                            <div className="card-body pt-4">
                                <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                  <image href="assets/undraw/undraw_sync.svg" x="0" y="0" height="100" width="100" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 py-3">
                        
                        <div className="card wow zoomIn shadow-sm">
                            <div className="card-header text-primary text-uppercase small">Report</div>
                            <div className="card-body pt-4">
                                <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                  <image href="assets/undraw/undraw_grades.svg" x="0" y="0" height="100" width="100" />
                                </svg>
                            </div>
                        </div>
                        
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 py-3">
                        <div className="card wow zoomIn shadow-sm">
                            <div className="card-header text-primary text-uppercase small">Analytics</div>
                            <div className="card-body pt-4">
                                <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                  <image href="assets/undraw/undraw_analytics.svg" x="0" y="0" height="100" width="100" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 py-3">
                        <div className="card wow zoomIn shadow-sm">
                            <div className="card-header text-primary text-uppercase small">Coding</div>
                            <div className="card-body pt-4">
                                <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                  <image href="assets/undraw/undraw_coding.svg" x="0" y="0" height="100" width="100" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 py-3">
                        <div className="card wow zoomIn shadow-sm">
                            <div className="card-header text-primary text-uppercase small">Team</div>
                            <div className="card-body pt-4">
                                <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                  <image href="assets/undraw/undraw_team.svg" x="0" y="0" height="100" width="100" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 py-3">
                        <div className="card wow zoomIn shadow-sm">
                            <div className="card-header text-primary text-uppercase small">Tutorial</div>
                            <div className="card-body pt-4">
                                <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                  <image href="assets/undraw/undraw_tutorial.svg" x="0" y="0" height="100" width="100" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 py-3">
                        <div className="card wow zoomIn shadow-sm">
                            <div className="card-header text-primary text-uppercase small">Tech</div>
                            <div className="card-body pt-4">
                                <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                  <image href="assets/undraw/undraw_laravel.svg" x="0" y="0" height="100" width="100" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 py-3">
                        <div className="card wow zoomIn shadow-sm">
                            <div className="card-header text-primary text-uppercase small">Messages</div>
                            <div className="card-body pt-4">
                                <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                  <image href="assets/undraw/undraw_messages.svg" x="0" y="0" height="100" width="100" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 py-3">
                        <div className="card wow zoomIn shadow-sm">
                            <div className="card-header text-primary text-uppercase small">Assets</div>
                            <div className="card-body pt-4">
                                <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                  <image href="assets/undraw/undraw_static.svg" x="0" y="0" height="100" width="100" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </Wrapper>
        );
    }
}

export default Illustrations;
